import { currencyTypes as actionTypes } from '@actions';
import { commonState, commonReducer } from '@dotone/react-ui-core/helpers';

const defaultState = {
  ...commonState.default({ localized: true, collection: true }),
};

export const currencyList = (state = defaultState, action) =>
  commonReducer(actionTypes, state, action);
